export const defaultSettings = {
  support: "https://discord.com/invite/FARNSbkZKt",
};
